import React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  text?: string;
}

const Spinner: React.FC<Props> = ({ text }) => {
  // const containerStyles = `${styles.container} ${styles.light} ${styles.rotate}`;
  // const dotStyles = `${styles.dot}`;

  return (
    <div className={styles.wrapper}>
      {
        // TODO_V2
        /* FLAGS.USE_LOADING_SPINNER && (
        <div
          className={containerStyles}
        >
          <div className={styles.inner_container}>
            <div className={styles.inner} />
          </div>
          <div className={styles.dot_container}>
            <div className={dotStyles} />
          </div>
        </div>
      ) */
      }
      {text ? <span className={styles.text}>{text}</span> : ''}
    </div>
  );
};

export default Spinner;
